import { render, staticRenderFns } from "./SmsConversations.vue?vue&type=template&id=3c115cae&scoped=true"
import script from "./SmsConversations.vue?vue&type=script&lang=js"
export * from "./SmsConversations.vue?vue&type=script&lang=js"
import style0 from "./SmsConversations.vue?vue&type=style&index=0&id=3c115cae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c115cae",
  null
  
)

export default component.exports